import { jsx } from 'panel';
import { ButtonEl } from 'common/components/button';
import { ButtonTheme } from 'common/components/button/constants';
import { InputEl } from 'common/components/input';
export function template() {
  const {
    isEditing,
    currText
  } = this.state;
  const MAX_DESCRIPTION_LENGTH = 300;
  return jsx("div", {
    sel: '.text-editor'
  }, !isEditing ? jsx("div", {
    sel: '.text-wrapper',
    class: {
      'text-empty': !currText
    },
    on: {
      click: () => !currText ? this.helpers.handleEditingStart() : null
    }
  }, currText ? this.helpers.formatText(currText, {
    className: "text",
    maxLength: MAX_DESCRIPTION_LENGTH
  }) : jsx("div", {
    on: {
      click: this.helpers.handleEditingStart
    }
  }, this.attr("add-text-placeholder") || "+Add Text..."), jsx("div", {
    sel: '.editable-icon'
  }, jsx(ButtonEl, {
    sel: '.edit-text-button',
    attrs: {
      icon: "edit",
      theme: ButtonTheme.Tertiary
    },
    on: {
      click: this.helpers.handleEditingStart
    }
  }))) : jsx(null, null, jsx(InputEl, {
    attrs: {
      type: "textarea",
      value: currText,
      placeholder: this.attr("placeholder")
    },
    on: {
      input: this.helpers.handleValueChange,
      blur: this.helpers.handleSaveByBlur,
      keydown: this.helpers.handleSaveByKeyPress
    },
    props: {
      value: currText
    },
    hook: {
      insert: this.helpers.handleInputInserted
    }
  }), !this.attr("hide-footer") ? jsx("div", {
    sel: '.text-editor-footer'
  }, jsx(ButtonEl, {
    on: {
      click: this.helpers.handleCancelEdit
    }
  }, "Cancel"), jsx(ButtonEl, {
    sel: '.save-button',
    attrs: {
      theme: ButtonTheme.Primary,
      disabled: !this.helpers.textChanged()
    },
    on: {
      click: this.helpers.handleSaveByButton
    }
  }, "Save")) : null));
}